import { ExternalUserFormDto, type ExternalUserFormInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

/** External user create/update request body for personal account mode - DTO signature */
export type ExternalUserLkFormInterface = Omit<ExternalUserFormInterface, 'isMailingEnabled' | 'client' | 'contragents'>

/** External user create/update request body for personal account mode - DTO schema */
export const ExternalUserLkFormDto = SerdeDtoClass.omit(
  SecurityDtoKeysEnum.EXTERNAL_USER_LK_FORM_DTO,
  ExternalUserFormDto,
  ['isMailingEnabled', 'client', 'contragents'],
);
